import React, { useState } from 'react';
import "./Contact.css";
import { Banner } from '../../Module_Exporter/Module_Exporter';
import { Email_Api_Address, MyEmail, Myaddress, contact_page_data, notifi_Theme1, whatsappNumber } from '../../functions/DefaultValues';
import {  toast} from 'react-toastify';
import { Helmet } from 'react-helmet-async';

import { https_request } from '../../functions/functions';
function Contact() {

  const initial_value={
    name:"",email:"",message:""
  }
const [ContactFields,SetContactFields] = useState(initial_value)

  function ManageFormFields(e)
  {
   const {name,value} = e.target;
   SetContactFields({
    ...ContactFields,
    [name]:value
   })
  }
  async function ManageContactForm(e)
  {
    e.preventDefault();
    if(!ContactFields.name.trim())  
  {
    toast.error("Please Enter Your Name!",notifi_Theme1);
  }
  else if(!ContactFields.email.trim())
  {
    toast.error("Please Enter Your Email!",notifi_Theme1);

  }
  else if(!ContactFields.message.trim())
  {
    toast.error("Please Enter Your Message!",notifi_Theme1);

  }
  else{
  SetContactFields({
  
    message:ContactFields.message.trim(),
    name:ContactFields.name.trim(),
    email:ContactFields.email.trim(),
  });
  const mail_credentials ={
  
    client_message:ContactFields.message.trim(),
    client_name:ContactFields.name.trim(),
    client_email:ContactFields.email.trim(),
  }
  // console.log(mail_credentials);
  const get_response = await https_request(Email_Api_Address,"POST",mail_credentials,true);
if(get_response.status===true)
{

  toast.success("Message Send Successfully!",notifi_Theme1);
  SetContactFields(initial_value);
}
else 
{

  toast.error("Please Check Your Internet Connection!",notifi_Theme1);
}


  // console.log(get_response);
  }

  }
// ---------------------
async function copyNumber()
{
  navigator.clipboard.writeText(whatsappNumber).then(function() {
    toast.info("Number Copied!",notifi_Theme1);
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });

}
// ---------------------




  return (
    <>
    <Helmet>    
    <title>CodeSperix-Contact</title>
    </Helmet>
    <main id='contact_page' >
    <Banner className="ContactBanner"  t1={contact_page_data.main_heading.t1} text={contact_page_data.main_heading_sub_headline} t2={contact_page_data.main_heading.t2} w={contact_page_data.bar.w}  />
     <div className="contact_form_container">
       <address data-aos="fade-right"  className='contact_info'>
<div onClick={copyNumber} id="mynumber" className="contact_item">
  <i className="fas fa-phone-alt"></i>
  <p>{whatsappNumber}</p>
</div>
<div id='myemail' onClick={()=>window.open(`mailto:${MyEmail}`,"_blank")} className="contact_item">
<i className="fas fa-envelope"></i>
  
  <p>{MyEmail}</p>
</div>
<div className="contact_item">
<i className="fas fa-map" ></i>
  <p>{Myaddress}</p>

</div>

       </address>
     <form data-aos="fade-left"  action="/#" method="post" id='contact_form' onSubmit={ManageContactForm} >

        <label htmlFor="name_field" className='dnone'>Your Name</label>
        <input type="text"  onChange={ManageFormFields} value={ContactFields.name}  name="name" placeholder='Enter Your Name*' id="name_field" />

        <label htmlFor="email_field"   className='dnone'>Your Email</label>
        <input type="email" name="email" onChange={ManageFormFields} value={ContactFields.email} placeholder='Enter Your Email*' id="email_field" />

       
        <textarea name="message"  onChange={ManageFormFields} value={ContactFields.message} placeholder='Your Message...*'  id="message_field" />


        <button type="submit"  id='form_btn' >SUBMIT</button>

      </form>


      {/* <iframe data-aos="fade-up" title='CodeSperix - Web Development Comapny Location' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3400.0175763065085!2d74.2890179746522!3d31.551132245623265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190375616819f3%3A0xb048b7ca899a0866!2sCoding%20Emperors%20%7C%20Web%20Developer%20%7C%20Full-Stack%20Developers%20%7C%20Agency!5e0!3m2!1sen!2s!4v1689842007840!5m2!1sen!2s" width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}

     </div>
    </main>
    </>
  )
}

export default Contact;